import { Dispatch } from '@reduxjs/toolkit';
import axiosInstance, { ApiKeys, getApiUrl } from '../utils/ApiHelper';
import { setCosmosVersionData } from '../reducers/commonSlice';
import { toast } from '@navi/web-ui/lib/primitives/Toast/core/toast';

export const fetchCosmosVersionData = () => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_COSMOS_APP_VERSION);
  return axiosInstance
    .get(url, {
      headers: {
        donothandleerror: true
      }
    })
    .then(response => {
      dispatch(setCosmosVersionData(response.data));
      return response.data;
    })
    .catch(error => {
      toast('Failed to fetch cosmos version data', { type: 'error' });
      throw error;
    });
};
